/**
 * Saldo restante no cupom giftcard após removePoints.
 * Legado (balance_giftcard.ejs): `log.points` — NÃO usar `log.value`
 * (em giftcard/pontos value costuma ser 0 e não é o saldo).
 */
export function extractReceiptBalance(
  redemptionData: unknown,
  fallbackBalance: number,
): number {
  if (!redemptionData || typeof redemptionData !== 'object') return fallbackBalance;
  const d = redemptionData as Record<string, unknown>;
  const log = d.log as Record<string, unknown> | undefined;

  const candidates = [log?.points, log?.currentBalance, d.points];
  for (const raw of candidates) {
    if (raw == null || raw === '') continue;
    const n = typeof raw === 'number' ? raw : Number(raw);
    if (Number.isFinite(n)) return n;
  }

  return fallbackBalance;
}
